import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {sumBy} from 'lodash';
import {Table, Card, Dropdown, Loader} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import TablePaginator from '../../../common/components/tablePaginator';

const OFFSET = 0;
const {
  fetchPrioritizationIndicesSummary,
  changePrioritizationIndicesListPage,
  changePrioritizationIndicesListPageSize,
} = Actions;

const TableLoader = () => {
  return (
    <Table.Row>
      <Table.Cell colSpan='100%'>
        <Loader active inline='centered' />
      </Table.Cell>
    </Table.Row>
  );
};

const Summary = ({list}) => {
  if (!list.length) {
    return (
      <Table.Row>
        <Table.Cell textAlign='center' colSpan={4}>
          No hay información para el rango de fechas solicitado
        </Table.Cell>
      </Table.Row>
    );
  }

  return list.map((element, index) => {
    return (
      <Table.Row key={index}>
        <Table.Cell textAlign='center'>{element.clientId}</Table.Cell>
        <Table.Cell textAlign='center'>{element.clientName}</Table.Cell>
        <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
        <Table.Cell textAlign='center'>
          {getNumericValue(element.average, 2)}
        </Table.Cell>
      </Table.Row>
    );
  });
};

const Totals = ({list}) => {
  function getQuantityTotal() {
    return sumBy(list, 'quantity') || 0;
  }

  return (
    <Table.Row className='totals-row'>
      <Table.Cell colSpan={2} textAlign='center'>
        TOTAL
      </Table.Cell>
      <Table.Cell textAlign='center'>{getQuantityTotal()}</Table.Cell>
      <Table.Cell />
    </Table.Row>
  );
};

const PrioritizationIndicesSummary = ({parameters}) => {
  const prioritizationIndices = useSelector(
    (state) => state.prioritizationIndices
  );
  const dispatch = useDispatch();
  const {pageSize, pageNumber, downloading, loading, list, itemsCount} =
    prioritizationIndices;
  const displayTotal = !loading && !downloading && list.length !== 0;

  function onPageClick(value) {
    dispatch(changePrioritizationIndicesListPage(value));
    dispatch(fetchPrioritizationIndicesSummary(parameters, pageSize, value));
  }

  function onPageSizeClick(event, data) {
    dispatch(changePrioritizationIndicesListPageSize(data.value));
    dispatch(fetchPrioritizationIndicesSummary(parameters, data.value, OFFSET));
  }

  return (
    <Card fluid raised>
      <Table striped>
        <Table.Header>
          <Table.Row textAlign='center'>
            <Table.HeaderCell>Ruc</Table.HeaderCell>
            <Table.HeaderCell>Cliente</Table.HeaderCell>
            <Table.HeaderCell>Unidades</Table.HeaderCell>
            <Table.HeaderCell>Promedio (días)</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {(loading || downloading) ? <TableLoader /> : <Summary list={list} />}
          {displayTotal && (<Totals list={list} />)}
        </Table.Body>

        {itemsCount > pageSize && (
          <Table.Footer>
            <Table.Row textAlign='center'>
              <Table.HeaderCell colSpan='100%'>
                <div className='table-pagination'>
                  <span className='page-sizer'>
                    <strong>Items por página</strong>
                    <Dropdown
                      selection
                      upward
                      compact
                      value={pageSize}
                      options={pageSizes}
                      onChange={onPageSizeClick}
                    />
                  </span>
                  <TablePaginator
                    itemsCount={itemsCount}
                    itemsPerPage={pageSize}
                    selectedPage={pageNumber}
                    onOptionClick={onPageClick}
                  />
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
    </Card>
  );
};

export default PrioritizationIndicesSummary;
